// Reveal au scroll : les éléments [data-reveal] apparaissent (fondu + léger slide)
// à leur entrée dans le viewport. Effet one-shot (unobserve après révélation).
// Les conteneurs [data-reveal-stagger] révèlent AUTOMATIQUEMENT leurs enfants directs
// en cascade : chaque enfant est numéroté (--i) pour un transition-delay échelonné
// (pas besoin de [data-reveal] sur chaque item — le CSS cible aussi [data-reveal-stagger] > *).
// Amélioration progressive : l'état masqué n'existe que sous .has-js (cf. CSS).
// Sous prefers-reduced-motion (ou sans IntersectionObserver), tout est révélé d'emblée.
export function initReveal() {
  // Cascade : numéroter les enfants des conteneurs stagger.
  document.querySelectorAll("[data-reveal-stagger]").forEach((group) => {
    Array.from(group.children).forEach((child, i) => {
      child.style.setProperty("--i", i);
    });
  });

  // Cibles : éléments isolés [data-reveal] + enfants directs des conteneurs stagger.
  const targets = document.querySelectorAll(
    "[data-reveal], [data-reveal-stagger] > *"
  );
  if (targets.length === 0) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (reduce.matches || !("IntersectionObserver" in window)) {
    // Pas d'animation : on rend la main au CSS naturel d'emblée (.reveal-done sort du système).
    targets.forEach((el) => el.classList.add("reveal-done"));
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        const el = e.target;
        el.classList.add("is-revealed");
        observer.unobserve(el); // one-shot

        // Fin de l'apparition → on retire l'élément du système de reveal (.reveal-done) pour
        // rendre la main au CSS naturel du composant (hover/transition propres, ex. lift des
        // cartes produit que sinon `transform: none` de l'état révélé écraserait).
        const done = (ev) => {
          if (ev.target !== el || ev.propertyName !== "opacity") return;
          el.classList.add("reveal-done");
          el.classList.remove("is-revealed");
          el.style.removeProperty("--i");
          el.removeEventListener("transitionend", done);
        };
        el.addEventListener("transitionend", done);
      }
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
  );

  targets.forEach((el) => io.observe(el));
}
